export default function getLicenseStatusClass(licenseStatus) {
    return {
        'badge badge-warning' : licenseStatus === 'LICENSE_USED',
        'badge badge-success' : licenseStatus === 'LICENSE_ASSIGNED',
        'badge badge-light'   : licenseStatus === 'LICENSE_UNASSIGNED',
        'badge badge-danger'  : licenseStatus === 'LICENSE_CANCELLED',
        'badge badge-info'    : licenseStatus === 'LICENSE_ACTIVE',
        'badge badge-dark'    : licenseStatus === 'LICENSE_WATCHING'
    }
}